import React, { FC } from 'react';
import { DecisionPointRowProps } from './DecisionPointRowProps';
import { Stack } from '@mui/material';
import Text from '@ingka/text';
import Status from '@ingka/status';
import Divider from '../Divider';
import { getFormattedDate } from '../ProjectListTable/utils';
import useTranslation from '../../hooks/useTranslation';

const DecisionPointRow: FC<DecisionPointRowProps> = ({ decisionPoint }) => {
  const t = useTranslation();

  const statusColor = {
    completed: 'positive',
    red: 'negative',
  };

  const dpLabel = `${decisionPoint.decisionPoint}${
    decisionPoint.overdraft ? ` ${t('dp.overdraft')}` : ''
  }${
    decisionPoint.decisionPointName
      ? ` – ${decisionPoint.decisionPointName}`
      : ''
  }`;
  const statusLabel = decisionPoint.completedDate
    ? `Completed : ${getFormattedDate(decisionPoint.completedDate)}`
    : `${decisionPoint.status}${
        decisionPoint.pointsResult ? ` (${decisionPoint.pointsResult})` : ''
      }`;

  return (
    <Stack spacing={0.5}>
      <Text textStyle="Body.M" style={{ color: 'black' }}>
        <b>{dpLabel}</b>
      </Text>
      <Status
        small
        label={statusLabel}
        variant={
          statusColor[decisionPoint.status.toLowerCase()] || 'indeterminate'
        }
      />
      <Divider />
    </Stack>
  );
};

export default DecisionPointRow;
